export const optionsCiudades = [
    { value: 'tijuana', label: 'Tijuana' },
    { value: 'mexicali', label: 'Mexicali' },
    { value: 'hermosillo', label: 'Hermosillo' }
  ]

export const optionsTransacciones = [
  { value: 'ingresos', label: "Ingresos" },
  { value: 'egresos', label: "Egresos" },
]  